<section class="page">
  <h1>Mot de passe oublié</h1>
  <form class="card" (ngSubmit)="submit()">
    <label class="field">
      <span>Email</span>
      <input [(ngModel)]="email" type="email" placeholder="nom@exemple.be" name="email" />
    </label>
    <button class="primary" type="submit" [disabled]="isLoading">
      {{ isLoading ? 'Envoi...' : 'Envoyer le lien' }}
    </button>
    <p class="success" *ngIf="message">{{ message }}</p>
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
  </form>
</section>
